module.exports = __webpack_public_path__ + "img/wechatPay.fad2c72e.png";